import { ToggleButton, ToggleButtonProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';


export type ButtonStyleRadioProps = ToggleButtonProps & {
  color?: 'primary' | 'secondary';
};


export const ButtonStyleRadio: React.VFC<ButtonStyleRadioProps> = ({ color = 'secondary', ...props }) => {
  const { classes } = useButtonStyleRadioStyles({ color, ...props }, { props: { color, ...props } });

  return (
    <ToggleButton
      {...props}
      classes={classes}
    />
  );
};


const useButtonStyleRadioStyles = makeStyles<Pick<ButtonStyleRadioProps, 'color'>>({ name: 'ButtonStyleRadio' })((theme, props) => ({
  root: {
    border: '1px solid rgba(0, 0, 0, 0.23) !important',
    borderRadius: '0 !important',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 2),
    textTransform: 'none',
    width: '100%',
    '&.Mui-selected': {
      backgroundColor: props.color
        ? theme.palette[props.color].background
        : undefined,
      borderColor: props.color
        ? theme.palette[props.color].main
        : undefined,
      color: props.color
        ? theme.palette[props.color].dark
        : undefined
    },
    justifyContent: 'flex-start',
  },
}));
